/**
 * Welche Aufgabe eine Firma im Unternehmensverbund übernimmt.
 *
 * Bewusst NICHT „Rolle" genannt: `role` ist im Verbund bereits die Beziehung
 * zur Ausgangsfirma (Tochter/Mutter/Schwester/Beteiligung). Zwei verschiedene
 * Dinge unter einem Namen wären in der Firmenliste des Risiken-Reiters, wo
 * beide nebeneinander stehen, nicht auseinanderzuhalten.
 *
 * Mehrfachauswahl, weil der Normalfall mehrfach ist: dieselbe GmbH führt den
 * Betrieb UND hält die Immobilie. Für die Risikobetrachtung ist genau das die
 * Frage — wer trägt das Betriebsrisiko, wer das Sachwertrisiko.
 *
 * Gespeichert als EIN String mit „; " verbunden (Spalte `unternehmensfunktion`),
 * wie `memberships` — kein Join für drei feste Werte.
 *
 * „Verwaltungsgesellschaft" stand hier bis zum 27.08.2026 und ist fachlich
 * gestrichen. Was schon erfasst wurde, bleibt lesbar: die Anzeige liest den
 * gespeicherten String roh (`funktionenAus`), und das Bildzeichen dafür steht
 * weiterhin in `brancheIcons.tsx`. Anwählbar ist der Wert nicht mehr — wer das
 * Feld das nächste Mal bearbeitet, schreibt ihn nicht mit zurück, weil
 * `OptionChips` ausschließlich aus diesem Vokabular schreibt.
 */
export const UNTERNEHMENSFUNKTIONEN = [
  "Betriebsgesellschaft",
  "Besitz-/Objektgesellschaft",
  "Holding-/Beteiligungsgesellschaft",
] as const;

export type Unternehmensfunktion = (typeof UNTERNEHMENSFUNKTIONEN)[number];

export const BESITZGESELLSCHAFT: Unternehmensfunktion = "Besitz-/Objektgesellschaft";

/**
 * Ist „Besitz-/Objektgesellschaft" gewählt (auch neben anderen Funktionen)?
 * Dann fragt die Anlage statt nach der Tätigkeit danach, was die Firma besitzt
 * (User 26.09.2026). Der Wert ist die „a; b"-Liste aus `OptionChips`.
 */
export const istBesitzgesellschaft = (wert: string | null | undefined): boolean =>
  String(wert ?? "")
    .split(/[;,]/)
    .map((t) => t.trim())
    .includes(BESITZGESELLSCHAFT);
